// extracted by mini-css-extract-plugin
module.exports = {"offset":"Triangles_offset__36Rn8"};